import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Faqs.css';
import FaqAccordian from '../../components/Faqs/Faqs';

class Faqs extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {

    return (
      <div className={s.root}>
        <div className={s.container}>
          <FaqAccordian />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Faqs);
